import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  Input,
  Output,
} from '@angular/core';
import { AIListProductCardViewModel } from '@app/lists/model/ai-list-product-card.model';

@Component({
  selector: 'app-ai-list-product-card',
  templateUrl: './ai-list-product-card.component.html',
  styleUrls: ['./ai-list-product-card.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AiListProductCardComponent {
  @Input() viewModel: AIListProductCardViewModel;
  @Input() isOnline: boolean;

  @Output() deleted: EventEmitter<AIListProductCardViewModel> =
    new EventEmitter();
  @Output() edited: EventEmitter<AIListProductCardViewModel> =
    new EventEmitter();
  @Output() clicked: EventEmitter<AIListProductCardViewModel> =
    new EventEmitter();

  constructor() {}

  onDelete() {
    this.deleted.emit(this.viewModel);
  }

  onEdit() {
    this.edited.emit(this.viewModel);
  }

  onProductClick() {
    this.clicked.emit(this.viewModel);
  }
}
